<p class="search-host--title" translate="search-page.experiences"></p>
<p class="search-host--subtitle" translate="search-page.saveable-itineraries"></p>

<div class="search-host--router-outlet">
  <experiences></experiences>
</div>

<p class="search-host--more-action" (click)="actionClicked.emit('experiences')"><em>{{ 'search-page.more-experiences' | translate }}</em></p>
